import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.ZOOM_BOOM;

export const QUESTIONS_COUNT_PER_LEVEL = 12;
export const QUESTIONS_COUNT_PER_LEVEL_SPANISH = 14;
export const MASTERY_CRITERIA = 0.8;

export const GLOBAL_WIDTH = 1024;
export const GLOBAL_HEIGHT = 576;

export const OPTION_STYLES = {
  BOX_SIDE_LENGTH: 140,
  DISTANCE_BETWEEN_OPTIONS: 185,
  FIRST_OPTION_X_POS: 225,
  X_DISTANCE_TO_DROPZONE: -55,
  Y_DISTANCE_TO_DROPZONE: -263,
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  HOME: 'HOME',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  INSTRUCTION: 'INSTRUCTION',
};

export const QUESTION_TYPES = {
  STANDARD: 'standard',
  INSTRUCTION: 'instruction',
};

export const DROPZONE_BORDER = {
  GRAY: 'GRAY',
  AQUA: 'AQUA',
  NONE: 'NONE',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INIT_BACKGROUNDS: 'INIT_BACKGROUNDS',
  SET_CURRENT_BACKGROUND: 'SET_CURRENT_BACKGROUND',
  LOAD_WORD_LIST: 'LOAD_WORD_LIST',
  LOAD_WORD_GROUPS: 'LOAD_WORD_GROUPS',
  SET_LEVEL: 'SET_LEVEL',
  GET_NEXT_QUESTION: 'GET_NEXT_QUESTION',
  INIT_QUESTION: 'INIT_QUESTION',
  SET_QUESTION: 'SET_QUESTION',
  RESET_QUESTION: 'RESET_QUESTION',
  SELECT_OPTION: 'SELECT_OPTION',
  UNSELECT_OPTION: 'UNSELECT_OPTION',
  HIGHLIGHT_OPTION: 'HIGHLIGHT_OPTION',
  UNHIGHLIGHT_OPTION: 'UNHIGHLIGHT_OPTION',
  SET_TARGET_IS_ACTIVE: 'SET_TARGET_IS_ACTIVE',
  UNLOCK_LEVEL: 'UNLOCK_LEVEL',
  SET_ONBOARDING_WAS_PLAYED: 'SET_ONBOARDING_WAS_PLAYED',
  INCREASE_CORRECT_ANSWERS_COUNT: 'INCREASE_CORRECT_ANSWERS_COUNT',
  SET_ALEX_STATE: 'SET_ALEX_STATE',
  SET_LAST_ALEX_AUDIO: 'SET_LAST_ALEX_AUDIO',
  SET_NEXT_ONBOARDING_PHASE: 'SET_NEXT_ONBOARDING_PHASE',
  RESET_ONBOARDING: 'RESET_ONBOARDING',
  SET_ONBOARDING_RETURN_TO: 'SET_ONBOARDING_RETURN_TO',
  RESET_INSTRUCTION_BG: 'RESET_INSTRUCTION_BG',
  CHANGE_INSTRUCTION_BG: 'CHANGE_INSTRUCTION_BG',
  ANSWER_INCORRECTLY: 'ANSWER_INCORRECTLY',
  SWITCH_QUESTION_BG_ANIMATION: 'SWITCH_QUESTION_BG_ANIMATION',
  SWITCH_ROUND_BG_ANIMATION: 'SWITCH_ROUND_BG_ANIMATION',
  QUICK_ROUND: 'QUICK_ROUND',
  SET_DROPZONE: 'SET_DROPZONE',
  DRAG_START: 'DRAG_START',
  DRAG_END: 'DRAG_END',
  DRAG_ENTER_DROPZONE: 'DRAG_ENTER_DROPZONE',
  DRAG_EXIT_DROPZONE: 'DRAG_EXIT_DROPZONE',
  SET_DROPZONE_BORDER: 'SET_DROPZONE_BORDER',
  LOAD_SAVED_DATA: 'LOAD_SAVED_DATA',
};

export const NUM_STANDARD_BACKGROUNDS = 4;
